import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { jsx } from 'react/jsx-runtime';
import { ListSubHeader } from '../../dataDisplay/List/ListSubHeader.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function MenuSubheader(props) {
  var children = props.children,
    action = props.action,
    rest = __rest(props, ["children", "action"]);
  return /*#__PURE__*/jsx(ListSubHeader, _extends({
    action: action,
    px: "md"
  }, rest, {
    children: children
  }));
}

export { MenuSubheader };
